import BaseEvent from './BaseEvent';
class CustomEvent extends BaseEvent {
}
export default CustomEvent;
//# sourceMappingURL=CustomEvent.js.map